import commonStyles from "utility/ui/common";

const styles = {
  controlBtn: (isMobile) => (isMobile ? commonStyles.controlBtnMobile : commonStyles.controlBtn),
};

export default styles;
